import { useIsReadOnlyClusterEligibleForRebalancingPlanCreation } from 'features/kent/hooks/useIsReadOnlyClusterEligibleForRebalancingPlanCreation';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useIsKentRebalancingMode = (): boolean => {
  const { cluster, isKentManaged } = useCluster();
  const isReadOnlyClusterEligibleForRebalancingPlanCreation =
    useIsReadOnlyClusterEligibleForRebalancingPlanCreation(cluster);

  return isKentManaged || isReadOnlyClusterEligibleForRebalancingPlanCreation;
};
